import script from "./RoleSectionListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionListModal.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionListModal.vue?vue&type=style&index=0&id=84c3deec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84c3deec"]])

export default __exports__